//creating our own hooks

import { useEffect, useState } from "react";

const useRestaurant =(resId)=>{
     const [restaurant, setRestaurant] = useState(null);

     useEffect(()=>{
          getRestaurantInfo();
     }, );
     async function getRestaurantInfo(){
          const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=26.76310&lng=83.37290&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING" + resId);
          const json = await data.json();
          console.log(json.data);
          setRestaurant(json.data);
     }
     return restaurant;

};
export default useRestaurant;